import { IApplicationState } from '../../types/redux';

export function getMarkedList(state: IApplicationState) {
  return state.newbuilding.markedList;
}
